module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/section03_05_beach-photo-d7ed444985ae7a495ac866d9cdeaed48.jpg";